var _path, _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolDefs1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-facebook",
    viewBox: "0 0 32 32"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12.4v3.867h3.467c.267 0 .4.267.4.533l-.533 2.533c0 .133-.267.267-.4.267h-2.933v9.733h-4v-9.6h-2.267c-.267 0-.4-.133-.4-.4V16.8c0-.267.133-.4.4-.4h2.267V12c0-2.267 1.733-4 4-4h3.6c.267 0 .4.133.4.4v3.2c0 .267-.133.4-.4.4h-3.2c-.267 0-.4.133-.4.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#173d33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 29.333h-8c-6.667 0-9.333-2.667-9.333-9.333v-8c0-6.667 2.667-9.333 9.333-9.333h8c6.667 0 9.333 2.667 9.333 9.333v8c0 6.667-2.667 9.333-9.333 9.333z",
    style: {
      stroke: "var(--color1, #173d33)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#97d28b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 16h16M16 24V8",
    style: {
      stroke: "var(--color2, #97d28b)"
    }
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-minus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M8 16h16"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left36",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.333,
    d: "m12.759 7.905-8.093 8.093 8.093 8.093M27.332 15.999H4.892"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right-16",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.882,
    d: "m19.05 8.382 7.617 7.617-7.617 7.617M5.333 16h21.12"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right36",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.333,
    d: "m19.241 7.905 8.093 8.093-8.093 8.093M4.668 15.999h22.44"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right-top",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.714,
    d: "M12.569 7.985h11.446v11.446M7.987 24.012 23.855 8.145"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right-top-16",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.882,
    d: "M12.77 8.456h10.772v10.772M8.459 23.541 23.393 8.607",
    style: {
      stroke: "var(--color3, #fff)"
    }
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-top",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m7.906 12.76 8.093-8.093 8.093 8.093M16 27.333V4.893"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bgAsset-324-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#173d33",
    d: "M22.018 19.932c-.067-.158-5.564-10.901-5.654-11.049a3.558 3.558 0 0 0-2.067-1.955 3.633 3.633 0 0 0-2.859.162 3.58 3.58 0 0 0-1.143.9 3.494 3.494 0 0 0-.311 4.075c.067.158 5.329 10.441 5.419 10.589.067.159.146.313.236.46a3.558 3.558 0 0 0 2.067 1.955 3.633 3.633 0 0 0 2.859-.162c.439-.219.829-.526 1.143-.9s.547-.809.683-1.275a3.496 3.496 0 0 0-.372-2.8z",
    style: {
      fill: "var(--color1, #173d33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#97d28b",
    d: "M15.669 12.663c.337-.354.596-.773.762-1.231s.234-.944.2-1.428c-.034-.485-.168-.957-.395-1.388s-.542-.811-.924-1.117c-.383-.306-.825-.531-1.3-.66s-.971-.161-1.459-.093c-.488.068-.956.235-1.375.489s-.781.592-1.063.99C9.997 8.349 1.07 19.198.971 19.338c-.337.354-.596.773-.762 1.231s-.234.944-.2 1.428a3.506 3.506 0 0 0 1.319 2.505 3.628 3.628 0 0 0 4.134.264c.42-.254.781-.591 1.063-.99.118-.124 9.045-10.973 9.144-11.113zM31.029 12.662c.337-.354.596-.773.762-1.231s.234-.944.2-1.428c-.033-.485-.168-.957-.395-1.388s-.542-.811-.924-1.117c-.383-.306-.825-.531-1.3-.66s-.971-.161-1.459-.093c-.488.068-.956.235-1.375.489s-.781.592-1.063.99c-.118.124-9.045 10.973-9.144 11.113-.337.354-.596.773-.762 1.231s-.234.944-.2 1.428c.033.485.168.957.395 1.388s.542.811.924 1.117a3.605 3.605 0 0 0 2.759.753c.488-.068.956-.235 1.375-.489s.781-.591 1.063-.99c.118-.124 9.045-10.973 9.144-11.113z",
    style: {
      fill: "var(--color2, #97d28b)"
    }
  })), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-call",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.293 24.44c0 .48-.107.973-.333 1.453s-.52.933-.907 1.36c-.653.72-1.373 1.24-2.187 1.573-.8.333-1.667.507-2.6.507-1.36 0-2.813-.32-4.347-.973s-3.067-1.533-4.587-2.64a38.332 38.332 0 0 1-4.373-3.733 37.98 37.98 0 0 1-3.72-4.36c-1.093-1.52-1.973-3.04-2.613-4.547-.64-1.52-.96-2.973-.96-4.36 0-.907.16-1.773.48-2.573.32-.813.827-1.56 1.533-2.227.853-.84 1.787-1.253 2.773-1.253.373 0 .747.08 1.08.24.347.16.653.4.893.747l3.093 4.36c.24.333.413.64.533.933.12.28.187.56.187.813 0 .32-.093.64-.28.947a4.52 4.52 0 0 1-.747.947l-1.013 1.053a.712.712 0 0 0-.213.533c0 .107.013.2.04.307.04.107.08.187.107.267.24.44.653 1.013 1.24 1.707.6.693 1.24 1.4 1.933 2.107.72.707 1.413 1.36 2.12 1.96.693.587 1.267.987 1.72 1.227.067.027.147.067.24.107a.92.92 0 0 0 .333.053c.227 0 .4-.08.547-.227l1.013-1c.333-.333.653-.587.96-.747.307-.187.613-.28.947-.28.253 0 .52.053.813.173s.6.293.933.52l4.413 3.133c.347.24.587.52.733.853.133.333.213.667.213 1.04z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cpu-charge",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.8 26.667h6.4c5.333 0 7.467-2.133 7.467-7.467v-6.4c0-5.333-2.133-7.467-7.467-7.467h-6.4c-5.333 0-7.467 2.133-7.467 7.467v6.4c0 5.333 2.133 7.467 7.467 7.467z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 22.667h4c3.333 0 4.667-1.333 4.667-4.667v-4c0-3.333-1.333-4.667-4.667-4.667h-4c-3.333 0-4.667 1.333-4.667 4.667v4c0 3.333 1.333 4.667 4.667 4.667zM10.68 5.333V2.666M16 5.333V2.666M21.333 5.333V2.666M26.667 10.667h2.667M26.667 16h2.667M26.667 21.333h2.667M21.333 26.667v2.667M16.013 26.667v2.667M10.68 26.667v2.667M2.667 10.667h2.667M2.667 16h2.667M2.667 21.333h2.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 12.933-1.253 2.187c-.28.48-.053.88.507.88h1.493c.56 0 .787.4.507.88l-1.253 2.187"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-global-edit",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M29.333 16C29.333 8.64 23.36 2.667 16 2.667S2.667 8.64 2.667 16 8.64 29.333 16 29.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.666 4h1.333a37.898 37.898 0 0 0 0 24h-1.333M20 4a38.083 38.083 0 0 1 1.947 12"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 21.333V20a38.083 38.083 0 0 0 12 1.947M4 12a37.898 37.898 0 0 1 24 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m25.614 20.987-4.72 4.72a1.64 1.64 0 0 0-.4.787l-.253 1.8c-.093.653.36 1.107 1.013 1.013l1.8-.253c.253-.04.613-.213.787-.4l4.72-4.72c.813-.813 1.2-1.76 0-2.96-1.187-1.187-2.133-.8-2.947.013z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M24.934 21.667c.4 1.44 1.52 2.56 2.96 2.96"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-iconamoon_close-light",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "m9.334 9.333 13.333 13.333m-13.333.001L22.667 9.334",
    style: {
      stroke: "var(--color3, #fff)"
    }
  })), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-instagram",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 29.333h8c6.667 0 9.333-2.667 9.333-9.333v-8c0-6.667-2.667-9.333-9.333-9.333h-8c-6.667 0-9.333 2.667-9.333 9.333v8c0 6.667 2.667 9.333 9.333 9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 20.667a4.667 4.667 0 1 0 0-9.334 4.667 4.667 0 0 0 0 9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M23.515 9.333h.015"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-map",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.053 10.373v12.973c0 2.533 1.8 3.573 3.987 2.32l3.133-1.787c.68-.387 1.813-.427 2.52-.067l7 3.507c.707.347 1.84.32 2.52-.067l5.773-3.307c.733-.427 1.347-1.467 1.347-2.32V8.652c0-2.533-1.8-3.573-3.987-2.32l-3.133 1.787c-.68.387-1.813.427-2.52.067l-7-3.493c-.707-.347-1.84-.32-2.52.067L4.4 8.067c-.747.427-1.347 1.467-1.347 2.307zM11.413 5.333v17.333M20.973 8.826v17.84"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-maximize-circle",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.667 4H28v5.333M20 12l8-8M9.333 28H4v-5.333M12 20l-8 8M18.693 2.933A13.794 13.794 0 0 0 16 2.666c-7.36 0-13.333 5.973-13.333 13.333 0 .92.093 1.813.267 2.667M13.307 29.067c.867.173 1.773.267 2.693.267 7.36 0 13.333-5.973 13.333-13.333 0-.907-.093-1.8-.267-2.667"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.882,
    d: "M4.706 9.726h22.588M4.706 16h22.588M4.706 22.274h22.588"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ranking",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M11.56 18.667H5.333a2.675 2.675 0 0 0-2.667 2.667v8h8.893V18.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.774 13.333h-3.56A2.675 2.675 0 0 0 11.547 16v13.333h8.893V16a2.666 2.666 0 0 0-2.667-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M26.667 22.667H20.44v6.667h8.893v-4c0-1.467-1.2-2.667-2.667-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16.693 2.76.707 1.413c.093.2.347.387.56.413l1.28.213c.813.133 1.013.733.427 1.307l-1 1c-.173.173-.267.493-.213.72l.28 1.227c.227.973-.293 1.347-1.147.84l-1.2-.707a.826.826 0 0 0-.787 0l-1.2.707c-.853.507-1.373.133-1.147-.84l.28-1.227c.053-.227-.04-.56-.213-.72l-.987-.987c-.587-.587-.4-1.173.427-1.307l1.28-.213a.89.89 0 0 0 .56-.413l.707-1.413c.387-.773 1-.773 1.387-.013z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sms",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M22.667 27.333H9.334c-4 0-6.667-2-6.667-6.667v-9.333c0-4.667 2.667-6.667 6.667-6.667h13.333c4 0 6.667 2 6.667 6.667v9.333c0 4.667-2.667 6.667-6.667 6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m22.667 12-4.173 3.333c-1.373 1.093-3.627 1.093-5 0L9.334 12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs1);
export default __webpack_public_path__ + "static/media/symbol-defs (1).111713e0c67bc15f0fe632b1953cef31.svg";
export { ForwardRef as ReactComponent };